import { RoutingManager } from './collaborators/routing-manager';

RoutingManager.shared.perform();